/**
 * Signup後オンボーディング（/signup/onboarding: URL入力→画像選択→無料バナー10枚）
 * の表示フラグ。
 *
 * 2026-07-18 調整のため一時非表示（ユーザー指示）。調整完了後に true へ戻すだけで
 * 全経路（SignupPage / CompleteSignInPage / CompanyOnboardingPage / SignupOnboardingPage）
 * が復活する。false の間、signup 完了後はそのまま /home へ遷移する。
 * バックエンド（/api/onboarding/signup/*）は生きたままで、非表示はフロントのみ。
 */
export const SIGNUP_ONBOARDING_ENABLED = false;

/**
 * signup 直後（/signup/setup 完了後）に /plans?from=signup（プラン選択→カード
 * 登録）へ送る導線のフラグ。
 *
 * この値は `SIGNUP_ONBOARDING_ENABLED = false` の間だけ意味を持つ。フル
 * オンボーディングが有効なときは、その出口（SignupOnboardingPage）が /plans へ
 * 遷移するため、CompanyOnboardingPage からは /signup/onboarding へ送れば足りる。
 *
 * 2026-07-24 フルオンボーディングは非表示のまま、カード登録導線のみ本番復活
 * （ユーザー指示）。
 */
export const SIGNUP_CARD_STEP_ENABLED = true;
